<template>
  <v-layout>
    <v-flex xs6 class="pa-0">
      <v-text-field v-model="content.quantity" type="number" label="Qty" @input="handleInput"></v-text-field>
    </v-flex>
    <v-flex xs6 class="pa-0">
      <v-select :items="periods" v-model="content.period" @input="handleInput" label="Select Period"></v-select>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "PeriodSelector",
  props: ['value'],
  data() {
    return {
      content: {
        quantity: this.value.quantity,
        period: this.value.period
      },
      periods: ['Minute', 'Hour', 'Day', 'Month', 'Year'],
    }
  },
  methods: {
    handleInput() {
      this.$emit('input', this.content);
    }
  }
}
</script>

<style scoped>

</style>
